import { render, staticRenderFns } from "./TemplateReports.vue?vue&type=template&id=78b85c4c"
import script from "./TemplateReports.vue?vue&type=script&lang=ts"
export * from "./TemplateReports.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports